<template>
  <Teleport to="body">
    <transition name="bk-slide-in" :duration="200">
      <Overlay v-if="placedAction" @close="onClose" @submit="onSubmit" />
    </transition>
  </Teleport>

  <PluginAddAction
    type="assistant"
    :title="$t('assistantAddAction', 'Add with AI Assistant')"
    :description="
  $t('assistantAddActionDescription', 'Add content using an AI assistant.')
"
    icon="robot"
    color="rose"
    @placed="placedAction = $event"
  />
</template>

<script setup>
import { useBlokkli, defineBlokkliFeature, ref } from "#imports";
import { PluginAddAction } from "#blokkli/plugins";
import Overlay from "./Overlay/index.vue";
const { adapter } = defineBlokkliFeature({
  id: "assistant",
  icon: "robot",
  label: "Assistant",
  description: "Provides a dynamic add block action to add one or more blocks generated by an AI assistant.",
  requiredAdapterMethods: [
    "assistantGetResults",
    "assistantAddBlockFromResult"
  ],
  screenshot: "feature-assistant.jpg",
  dependencies: ["add-list"]
});
const { state, $t } = useBlokkli();
const placedAction = ref(null);
const onClose = () => {
  placedAction.value = null;
};
const onSubmit = async (result) => {
  if (adapter.assistantAddBlockFromResult && placedAction.value) {
    await state.mutateWithLoadingState(
      () => adapter.assistantAddBlockFromResult({
        result,
        host: placedAction.value.host,
        preceedingUuid: placedAction.value.preceedingUuid
      }),
      $t("assistantAddResultError", "Failed to add block from assistant.")
    );
  }
  onClose();
};
</script>

<script>
export default {
  name: "Assistant"
};
</script>
